<template>
  <el-select
    v-model="value"
    clearable
    size="large"
    filterable
    placeholder="Select branches"
    multiple
    class="w-100"
  >
    <el-option
      v-for="item in branches"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "BranchesDropdownMulti",
  data() {
    return {
      value: ""
    };
  },
  methods: {
    ...mapActions("ListsModule", ["fetchBranches"])
  },
  mounted() {
    this.fetchBranches();
  },
  computed: {
    ...mapGetters("ListsModule", ["branches"])
  }
});
</script>
